module.exports = __webpack_public_path__ + "img/nature-36.32e88bfc.jpg";